// extracted by mini-css-extract-plugin
export default {"body":"PungoOpinionCard_body__HoyvZ","container":"PungoOpinionCard_container__cRpxi","triangle":"PungoOpinionCard_triangle__qJK2U","author":"PungoOpinionCard_author__3xVr-"};